import React, { forwardRef } from 'react'
import Box from '@mui/system/Box'

interface TabBoxProps {
  children: React.ReactNode
  sx?: any
}

const TabBox = forwardRef<HTMLDivElement, TabBoxProps>(({ children, sx = {} }, ref) => {
  return (
    <Box
      ref={ref}
      sx={{
        backgroundColor: '#fff',
        border: 'solid 1px #DADBDF',
        padding: '16px 24px',
        borderRadius: '8px',
        fontFamily: 'Source Sans Pro',
        fontSize: '16px',
        fontWeight: 400,
        textAlign: 'left',
        marginTop: { md: 1.5, lg: 2, xl: 3 },
        overflow: 'auto',
        height: '100%',
        ...sx,
      }}
    >
      {children}
    </Box>
  )
})

TabBox.displayName = 'TabBox'

export default TabBox
